import './Charts.css'

import React, {useContext, useEffect, useRef, useState} from 'react';
import PageLayout from "../../layout/page-layout/PageLayout";
import {useNavigate, useParams} from "react-router-dom";
import FlexBox from "../../components/utilities/FlexBox";
import {convertQueryStringToObject} from "../../utilities/Utilities";
import CanvasJSReact from '@canvasjs/react-charts';
import ReactDOM from "react-dom";
import {IFRAME_DOMAIN} from "../../utilities/Constants";
import JustGauge from 'justgage';
import CompanyTeamContext from "../../CompanyTeamContext";
import companyTeamContext from "../../CompanyTeamContext";
import {Button} from "react-bootstrap";
import axios from "axios";
import {API_URL_PREFIX} from "../../utilities/Constants";
import { ReactComponent as TimeChartIcon } from '../../assets/chart/timeChart.svg';
import { ReactComponent as HighReliabilityIcon } from '../../assets/chart/highReliability.svg';
import { ReactComponent as MediumReliabilityIcon } from '../../assets/chart/mediumReliability.svg';
import { ReactComponent as LowReliabilityIcon } from '../../assets/chart/lowReliability.svg';
import { ReactComponent as ArrowIcon } from '../../assets/chart/arrow.svg';
import { ReactComponent as RiskyFaceIcon } from '../../assets/chart/riskyFace.svg';
import { ReactComponent as RiskyScreenIcon } from '../../assets/chart/riskyScreen.svg';
import { ReactComponent as OpenModalIcon } from '../../assets/chart/openModal.svg';
import {IframeModal} from "../quiz/quiz/QuizzesList";

const CanvasJS = CanvasJSReact.CanvasJS;
const CanvasJSChart = CanvasJSReact.CanvasJSChart;

let correctCount = 0;
let totalQCount = 0;
var enhanced;

function Header({testName, candidateName}) {
    return <FlexBox className={"container"} align={"center"} justify={"start"} style={{
        background: "#4760F1", height: "80px", padding: "20px", boxSizing: "border-box"
    }}>
        <FlexBox justify={"space-between"}>
            <div style={{
                lineHeight: "20px", color: "#fff", fontWeight: "800", fontSize: "20px"
            }}> {`${testName} Test Results of ${candidateName}`}
            </div>
        </FlexBox>
    </FlexBox>;
}

const Charts = ({}) => {
    const {results} = useParams();

    const data = convertQueryStringToObject(results)

    const company = useContext(companyTeamContext)
    const navigate = useNavigate()
    const [reliability, setReliability] = useState(null)
    const [reliabilityData, setReliabilityData] = useState(null)
    const [showIframe, setShowIframe] = useState(false)
    const [iframeSrc, setIframeSrc] = useState("")

    useEffect(() => {
        if(company){
            document.title  = "Test Charts - " + company.basicTitle
            return () => {
                document.title = company.basicTitle
            }
        }
    },[company])

    useEffect(() => {
        if(data.testKey){
            axios.post(API_URL_PREFIX+"/GetTestReliability.html", null, { params: { testKey: data.testKey } })
                .then(res => {
                    if(res.data && res.data.result === true){
                        const riskImageCount = res.data.riskImageCount || 0
                        const screenShotRiskLevel = res.data.screenShotRiskLevel || 0
                        const riskScreenshotCount = res.data.riskScreenshotCount || 0
                        const hasRiskyImages = riskImageCount >= 5
                        const hasHighRiskScreenshot = screenShotRiskLevel >= 3
                        const hasAiScreenshot = res.data.hasAiScreenshot || false
                        const phoneSnapshotsTaken = res.data.phoneSnapshotsTaken || 0
                        const phoneSnapshotsExpected = res.data.phoneSnapshotsExpected || 0
                        const spEnabled = phoneSnapshotsExpected > 0
                        const hasLowMobileCoverage = spEnabled && (phoneSnapshotsTaken / phoneSnapshotsExpected) < 0.9

                        let level = 'High'
                        if(hasLowMobileCoverage || hasAiScreenshot || (hasRiskyImages && hasHighRiskScreenshot)){
                            level = 'Low'
                        } else if(hasRiskyImages || hasHighRiskScreenshot){
                            level = 'Medium'
                        }
                        setReliability(level)
                        setReliabilityData({riskImageCount, riskScreenshotCount, spEnabled})
                    }
                })
                .catch(e => {
                    console.error("Error fetching reliability", e)
                })
        }
    },[data.testKey])

    return (
        <PageLayout height={"100%"} padding={"0px"}>
            <Button onClick={()=> navigate(-1)} variant={"outline-light"} style={{position:"absolute", top:15,right:15, zIndex:6}}>Back</Button>
            <span style={{}}>
            <Header candidateName={data.cand} testName={data.quizName}/>
            <div style={{
                justifyContent: "top",
                display: "flex",
                height: "calc(100% - 80px)",
                width: "100%",
                flexDirection: "column",
                padding: "30px"
            }}>
                <div style={{width:"100%"}}>
                    <p style={{fontWeight:"bold"}}>Topics Review</p>
                    <TopicsReview data={data}/>
                </div>
                <FlexBox className={"wrapper"} justify={"space-between"} style={{width:"100%", padding:"10px"}}>
                    <ScoreReview data={data} />
                    <ReliabilityReview reliability={reliability} reliabilityData={reliabilityData} data={data} setShowIframe={setShowIframe} setIframeSrc={setIframeSrc} candidateTime={data.candidateTime} totalTime={data.totalTime} />
                </FlexBox>

            </div>
            </span>
            {showIframe && <IframeModal setShow={setShowIframe} src={iframeSrc} />}
        </PageLayout>)
};

const TopicsReview = ({data}) => {

    var dataPointsArr = initQuizResultsDetails(data.results)

    CanvasJS.addColorSet("successColorSet",
        [//colorSet Array
            "#d65b4a",
            "#da932c",
            "#66b92e"
        ]);



    CanvasJS.addColorSet("timeColorSet",
        [//colorSet Array
            "#d65b4a",
            "transparent"
        ]);

    let options = {
        title:{
            text: ""
        },
        colorSet: "topicsColorSet",
        animationEnabled: true,
        axisX:{interval: 1} ,
        panEnabled: true,

        toolTip:{
            shared: true,
        },
        axisY:{
            minimum: 0,
            gridThickness: .0,
            maximum: 1,
            valueFormatString:"#%"
        },
        data: [
            {
                type: "bar",
                dataPoints: dataPointsArr
            }

        ]
    }

    if(dataPointsArr && dataPointsArr.length == 1){
        options = {
            colorSet: "topicsColorSet",
            title:{
                text: ""
            },
            toolTip:{
                shared: true,
            },
            axisY:{
                minimum: 0,
                gridThickness: .2,
                maximum: 1,
                valueFormatString:"#%"
            },
            data: [
                {
                    type: "bar",
                    dataPoints: []
                }
            ]
        }
        options.data[0].dataPoints = dataPointsArr
    }

    return (
        <div style={{width:"100%"}}>
            <CanvasJSChart containerProps={{height:"350px"}} options = {options} />
        </div>
    )
}

const ScoreReview = ({data}) => {
    let cColor;
    const {score} = data
    if(score > 0 && score <= 50){
        cColor ="#d65b4a"
    }
    else if( score > 50 && score <= 80){
        cColor="#da932c"
    }
    else{
        cColor="#66b92e"
    }

    let options = {
        animationDuration: 800,
        animationEnabled: true,
        width:270,
        backgroundColor: "transparent",
        theme: "theme2",
        title: {
            fontSize: 55,
            fontFamily:"Segoe UI",
            verticalAlign: "center",
            text: (""+Math.floor(data.score || 0)).trim()
        },
        subtitles:[
        ],
        data: [
            {
                innerRadius: "82%",
                radius: "90%",
                legendMarkerType: "square",
                showInLegend: false,
                startAngle: 90,
                type: "doughnut",
                dataPoints: [
                    {  y: score, name: "Weak" ,color:cColor},
                    {  y: 100-score, name: "Good" ,color:"lightgray"},

                ]
                //toolTipContent: "<span style='\"'color: ;'\"'>{name}</span>: <b>{y}</b>"
            }
        ],
        toolTip:{
            enabled: false,
        }
    }

    let scoreStats = 'NA';
    let scoreBg = '';
    let scoreColor = '';
    if(score>=0){
        if(score<50){
            scoreStats = 'Weak';
            scoreBg = '#FFF0F0';
            scoreColor = '#B80000';
        }else if(score>=50 && score <80){
            scoreStats = 'Good';
            scoreBg = '#FFF5EB';
            scoreColor = '#C27F02';
        }else{
            scoreStats = 'Excellent';
            scoreBg = '#F1FDF4';
            scoreColor = '#064F05';
        }
    }


    const {totalTime, candidateTime, cand, quizName} = data
    let lblt = ' Test';
    if(quizName.toLowerCase().indexOf("test")!=-1){
        lblt = '';
    }
    let timeAddition = <b>This test had no time limit</b>
    if(parseFloat(totalTime)>0){
        timeAddition = <div>This test had a time limitation of <b>{totalTime} minutes.</b></div>;
    }

    return (
        <div style={{width:"100%", borderRight:"1px solid #ccc"}}>

            <FlexBox justify={"space-between"} style={{width:"100%", padding:"10px"}}>
                <CanvasJSChart containerProps={{height:"270px", width:"270px"}} options = {options} />
                <FlexBox direction={"column"} align={"start"} justify={"start"} style={{width: "calc(100% - 270px)", height:"100%"}}>
                    <div style={{width:"310px", marginBottom:"15px"}}>{data.cand} has taken the <b style={{display:"inline"}}>{data.quizName}</b> Test and got <b>{Math.floor(data.score || 0)}</b> out of <b>100 points</b>.</div>
                    <div style={{padding:"15px", background:scoreBg, color:scoreColor, border:"none", fontWeight:"200", width:"310px", borderRadius:"7px", height:"45px", display:"flex", alignItems:"center"}}>
                        This score considered to be {scoreStats}.
                    </div>
                    {data.testKey && (
                        <div style={{width:"310px", borderTop:"1px solid #909090", marginTop:"15px", paddingTop:"15px"}}>
                            <div style={{display:"flex", alignItems:"center", gap:"8px"}}>
                                <TimeChartIcon style={{flexShrink:0}} />
                                <span>{cand} has finished the <b>{quizName}</b>{lblt} in <b>{candidateTime} minutes</b>.</span>
                            </div>
                            <div style={{marginTop:"8px"}}>{timeAddition}</div>
                        </div>
                    )}
                </FlexBox>
            </FlexBox>

        </div>
    )
}

const reliabilityConfig = {
    High: {
        borderColor: '#52cda4',
        badgeBg: '#F1FDF4',
        badgeColor: '#064F05',
        text: 'The assessment was completed under reliable conditions with minimal integrity concerns.',
        Icon: HighReliabilityIcon
    },
    Medium: {
        borderColor: '#ffd17c',
        badgeBg: '#FFF5EB',
        badgeColor: '#C27F02',
        text: 'The assessment was completed under reliable conditions, with some integrity concerns detected.',
        Icon: MediumReliabilityIcon
    },
    Low: {
        borderColor: '#ff8885',
        badgeBg: '#FFF0F0',
        badgeColor: '#B80000',
        text: 'The assessment was completed under low reliability conditions, with multiple integrity concerns identified.',
        Icon: LowReliabilityIcon
    }
}

const ReliabilityReview = ({reliability, reliabilityData, data, setShowIframe, setIframeSrc, candidateTime, totalTime}) => {
    const [expanded, setExpanded] = useState(false)


    if(!data.testKey){
        const candidateTimeNum = Math.round(candidateTime || 0);
        const totalTimeNum = Math.round(totalTime || 0);


        const hasLimit = totalTimeNum > 0;
        const maxVal = hasLimit ? totalTimeNum : 100;
        const val = Math.min(candidateTimeNum, maxVal);

        // 70% if no limit, otherwise calculate %
        const pct = hasLimit ? (val / maxVal) : 0.7;

        const r = 120;
        const cx = 150;
        const cy = 140;
        const circumference = Math.PI * r;
        const dashOffset = circumference * (1 - pct);

        // Knob Position
        const angle = Math.PI * (1 - pct);
        const knobX = cx + r * Math.cos(angle);
        const knobY = cy - r * Math.sin(angle);
        return (
            <div style={{ width: "100%", padding: "10px" }}>
                <div style={{ textAlign: "center" }}>
                    <div style={{ position: "relative", width: "300px", height: "180px", margin: "0 auto" }}>
                        <svg width="300" height="200">
                            {/* Background Arc (Grey) */}
                            <path d="M 30 140 A 120 120 0 0 1 270 140" fill="none" stroke="#E1E7EF" strokeWidth="20" strokeLinecap="round" />

                            {/* Foreground Arc (Blue) */}
                            <path d="M 30 140 A 120 120 0 0 1 270 140" fill="none" stroke="#5A7AFF" strokeWidth="20" strokeLinecap="round"
                                  strokeDasharray={circumference} strokeDashoffset={dashOffset}
                                  style={{ transition: "stroke-dashoffset 1s ease-in-out" }} />
                            {/* The Knob */}
                            <circle cx={knobX} cy={knobY} r="14" fill="#FFFFFF" stroke="#5A7AFF" strokeWidth="5" />

                            {/* Edge Labels - Only show if hasLimit is true */}
                            {hasLimit && (
                                <>
                                    <text x="30" y="175" textAnchor="middle" fontFamily="Nunito Sans" fontSize="14" fill="#000000" fontWeight="bold">0</text>
                                    <text x="270" y="175" textAnchor="middle" fontFamily="Nunito Sans" fontSize="14" fill="#000000" fontWeight="bold">{Math.round(maxVal)}</text>
                                </>
                            )}


                            <text x="150" y="135" textAnchor="middle" fontFamily="Nunito Sans" fontSize="42" fill="#3b517c" fontWeight="bold">{candidateTimeNum}</text>
                            <text x="150" y="160" textAnchor="middle" fontFamily="Nunito Sans" fontSize="14" fill="#94A2B8" fontWeight="600">minutes</text>
                        </svg>
                    </div>

                    {/* Bottom Details */}
                    <div style={{ marginTop: "20px" }}>
                        <div style={{ fontSize: "15px", marginBottom: "5px" }}>
                            <span style={{ color: "#63748A", fontWeight: "600" }}>Completed in </span>
                            <span style={{ color: "#334155", fontWeight: "bold" }}>{candidateTimeNum} minutes</span>
                        </div>
                        <div style={{ fontSize: "15px" }}>
                            <span style={{ color: "#63748A", fontWeight: "600" }}>Time Limit: </span>
                            <span style={{ color: "#4B5563", fontWeight: "bold" }}>{hasLimit ? `${totalTimeNum} minutes` : "No Limit"}</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    if(!reliability) return <div style={{width:"100%"}}></div>

    const config = reliabilityConfig[reliability]
    if(!config) return <div style={{width:"100%"}}></div>

    const {borderColor, badgeBg, badgeColor, text, Icon} = config

    const openProfileImages = () => {
        setShowIframe(true)
        setIframeSrc(`${IFRAME_DOMAIN}/ShowProfileImages.html?liteColor=1&quizId=${encodeURIComponent(data.testKey)}&candName=${encodeURIComponent(data.cand)}`)
    }

    const openScreenshots = () => {
        setShowIframe(true)
        setIframeSrc(`${IFRAME_DOMAIN}/PrintScreenReport.htm?liteColor=1&testKey=${encodeURIComponent(data.testKey)}&testName=${encodeURIComponent(data.quizName)}&applicantName=${encodeURIComponent(data.cand)}`)
    }

    return (
        <div style={{width:"100%", padding:"10px"}}>
            <div style={{
                borderRadius:"15px",
                border:`1.5px solid ${borderColor}`,
                overflow:"hidden",
                display:"flex",
                flexDirection:"column"
            }}>

                <div id="reliabilityTopSection" style={{
                    height: expanded ? "auto" : "145px",
                    background: badgeBg,
                    padding: expanded ? "13px 21px" : "17px 21px",
                    display:"flex",
                    alignItems:"center",
                    justifyContent:"space-between",
                    transition:"all 0.3s ease"
                }}>
                    <div style={{display:"flex", flexDirection:"column", justifyContent:"flex-start", alignSelf:"stretch", paddingTop:"4px"}}>
                        {/* Badge */}
                        <div style={{
                            width:"122px",
                            height:"34px",
                            borderRadius:"21px",
                            border:`1.5px solid ${badgeColor}`,
                            color: badgeColor,
                            background: badgeBg,
                            display:"flex",
                            alignItems:"center",
                            justifyContent:"center",
                            fontFamily:"Nunito",
                            fontWeight:"700",
                            fontSize:"12px"
                        }}>
                            {reliability} Reliability
                        </div>
                        {/* Description text - hidden when expanded */}
                        {!expanded && (
                            <div style={{
                                marginTop:"13px",
                                fontFamily:"Nunito",
                                fontWeight:"600",
                                fontSize:"15px",
                                color:"#000",
                                lineHeight:"1.4",
                                maxWidth:"357px"
                            }}>
                                {text}
                            </div>
                        )}
                    </div>

                    <div style={{flexShrink:0}}>
                        <Icon style={{width: expanded ? "43px" : undefined, height: expanded ? "43px" : undefined, transition:"all 0.3s ease"}} />
                    </div>
                </div>

                <div style={{borderTop:`1.5px solid ${borderColor}`}}></div>
                {/* Second section */}
                <div style={{
                    height:"72px",
                    background:"#fff",
                    padding:"0 21px",
                    display:"flex",
                    alignItems:"center",
                    justifyContent:"space-between",
                    cursor:"pointer"
                }} onClick={() => setExpanded(!expanded)}>
                    <span style={{
                        fontFamily:"Nunito",
                        fontWeight:"700",
                        fontSize:"16px",
                        color:"#374151"
                    }}>
                        View Detailed Breakdown ({reliabilityData ? reliabilityData.riskImageCount + reliabilityData.riskScreenshotCount : 0})
                    </span>
                    <ArrowIcon style={{
                        flexShrink:0,
                        transition:"transform 0.3s ease",
                        transform: expanded ? "rotate(180deg)" : "rotate(0deg)"
                    }} />
                </div>

                <div style={{
                    overflow:"hidden",
                    transition:"max-height 0.3s ease",
                    maxHeight: expanded ? "136px" : "0px",
                    background:"#fff"
                }}>
                    <div style={{
                        padding:"0 21px 17px 21px"
                    }}>
                        <div style={{
                            width:"596px",
                            maxWidth:"100%",
                            height:"111px",
                            borderRadius:"12px",
                            background:"#F9FAFB",
                            display:"flex",
                            flexDirection:"column",
                            justifyContent:"center",
                            padding:"0 17px",
                            gap:"14px"
                        }}>
                            {/* Row 1 - Risky Face Captures */}
                            <div style={{display:"flex", alignItems:"center", justifyContent:"space-between", cursor:"pointer"}} onClick={(e) => { e.stopPropagation(); openProfileImages(); }}>
                                <div style={{display:"flex", alignItems:"center", gap:"8px"}}>
                                    <RiskyFaceIcon style={{flexShrink:0}} />
                                    <span style={{
                                        fontFamily:"Nunito",
                                        fontWeight:"700",
                                        fontSize:"14px",
                                        color:"#374151",
                                        textDecoration:"underline"
                                    }}>
                                        {reliabilityData && reliabilityData.spEnabled ? 'Risky Camera Activity' : 'Risky Face Captures'}
                                    </span>
                                    <OpenModalIcon style={{flexShrink:0}} />
                                </div>
                                <span style={{
                                    fontFamily:"Nunito",
                                    fontWeight:"700",
                                    fontSize:"14px",
                                    color: badgeColor,
                                    background: badgeBg,
                                    padding:"2px 8px",
                                    borderRadius:"5px"
                                }}>
                                    {reliabilityData ? reliabilityData.riskImageCount : 0}
                                </span>
                            </div>
                            {/* Row 2 - Risky Screen Captures */}
                            <div style={{display:"flex", alignItems:"center", justifyContent:"space-between", cursor:"pointer"}} onClick={(e) => { e.stopPropagation(); openScreenshots(); }}>
                                <div style={{display:"flex", alignItems:"center", gap:"8px"}}>
                                    <RiskyScreenIcon style={{flexShrink:0}} />
                                    <span style={{
                                        fontFamily:"Nunito",
                                        fontWeight:"700",
                                        fontSize:"14px",
                                        color:"#374151",
                                        textDecoration:"underline"
                                    }}>
                                        Risky Screen Captures
                                    </span>
                                    <OpenModalIcon style={{flexShrink:0}} />
                                </div>
                                <span style={{
                                    fontFamily:"Nunito",
                                    fontWeight:"700",
                                    fontSize:"14px",
                                    color: badgeColor,
                                    background: badgeBg,
                                    padding:"2px 8px",
                                    borderRadius:"5px"
                                }}>
                                    {reliabilityData ? reliabilityData.riskScreenshotCount : 0}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const TimeReview = ({data}) => {
    const {totalTime, candidateTime, cand, quizName} = data
    let lblt = ' Test';
    if(quizName.toLowerCase().indexOf("test")!=-1){
        lblt = '';
    }
    let candidateTimeStr;
    let totalTimeStr;
    if(candidateTime==1){
        candidateTimeStr = "1 min";
    }else if(candidateTime>=0){
        candidateTimeStr = candidateTime+" min";
    }else{
        candidateTimeStr = "NA";
    }
    if (totalTime > 0){
        totalTimeStr = totalTime +" min";
    }else{
        totalTimeStr = "0";
    }
    let addition = <b>This test had no time limit</b>
    if(parseFloat(totalTime)>0){
        addition = <div>This test had a time limitation of <b>{totalTime} minutes.</b></div>;
    }
    let all = <div>{cand} has finished the <b>{quizName}</b>{lblt} in <b>{candidateTime} minutes</b>.<br/><br/>{addition}</div>;

    console.log(totalTimeStr)
    return (
        <FlexBox justify={"space-between"} align={"center"} style={{ width:"100%", padding:"10px"}}>
            {totalTimeStr != "0" &&  <Gauge candidateTimeStr={candidateTime} totalTimeStr={totalTime} />}
            <div style={{width:"40%"}}>{all}</div>
        </FlexBox>
    )
}

const Gauge = ({candidateTimeStr, totalTimeStr}) => {
    const gaugeRef = useRef(null); // To hold our gauge element
    let gaugeInstance = null;     // Will store the JustGauge instance

    useEffect(() => {
        // Create a new JustGauge instance on component mount
        gaugeInstance = new JustGauge({
            id: gaugeRef.current.id,
            titleFontFamily: "Segoe UI",
            valueFontFamily:  "Segoe UI",

            labelMinFontSize:"20px",
            value: candidateTimeStr,
            min: 0,
            max: totalTimeStr,
            label: "minutes",
            levelColors: [
                "#66b92e",
                "#da932c",
                "#d65b4a"
            ],
            gaugeWidthScale: 1,
            valueFontColor: "#292b2c",
            labelFontColor: "#595c5e",
            pointer: true,
            pointerOptions: {
                toplength: -15,
                bottomlength: 10,
                bottomwidth: 6,
                color: '#595c5e',
                stroke: '#ffffff',
                stroke_width: 2,
                stroke_linecap: 'round'
            }
        });

        return () => {
            // Optional: Clean up on component unmount
            gaugeInstance = null;
        };
    }, []);

    useEffect(() => {
        // Update JustGauge value if the props.value changes
        if (gaugeInstance) {
            gaugeInstance.refresh(candidateTimeStr);
        }
    }, [candidateTimeStr, totalTimeStr]);

    return <div style={{width:"60%"}} id={`gauge`} ref={gaugeRef}></div>;
};

function initQuizResultsDetails(results) {
    var quizResultsList = new Array();
    var arrColors = new Array();

    if(results.length == 0)return;
    var classifyNames = new Array();
    var arr = results.split('_QQQ_');
    var summarySF = new Object();
    //if(arr.length > 10){
    var newArray  = "";
    for (var z = 0 ; z< arr.length ; z++){
        var line = arr[z];
        var cls = line.split('->');
        var pos = 0;
        var areaName;
        if(cls.length==5){
            areaName = cls[pos++];
        }
        var categoryName = cls[pos++];
        var versionName = cls[pos++];
        var topicName = cls[pos++];
        var difficulty;
        try{
            difficulty = cls[pos].charAt(0);
        }catch(err){
            console.log(1);
        }
        var orgCatName = categoryName;
        if(categoryName=='Custom'){
            categoryName = topicName;
        }
        if(areaName){
            if(areaName == 'Coding'){
                categoryName = categoryName +' (Coding)';
            }
        }
        if(enhanced && enhanced=='true'){
            topicName = topicName.split('+').join(' ');
            topicName = topicName.split(',').join(' ');
            if(orgCatName!='Custom'){
                categoryName = categoryName+' '+versionName+' - '+topicName;
            }
        }
        if(summarySF[categoryName]==null){
            var successFail = new Object();
            successFail.Failures = 0;
            successFail.Successes = 0;
            summarySF[categoryName] = successFail;
        }

        //Duplicate Code
        var  success = line.split('_success_');
        var successNumber = 0;
        if(success.length > 1){
            var tmp = success[1];
            if(tmp.length > 1){
                if(!isNaN(parseInt(tmp.charAt(1)))){
                    successNumber = parseInt(tmp.charAt(0)+tmp.charAt(1));
                }else{
                    successNumber = parseInt(tmp.charAt(0));
                }
            }else{
                successNumber = parseInt(tmp.charAt(0));
            }
        }
        summarySF[categoryName].Successes += successNumber;
        totalQCount += successNumber;
        correctCount += successNumber;
        var  failures = line.split('_failed_');
        var failuresNumber = 0;
        if(failures.length > 1){
            var tmp = failures[1];
            if(tmp.length > 1){
                if(!isNaN(parseInt(tmp.charAt(1)))){
                    failuresNumber = parseInt(tmp.charAt(0)+tmp.charAt(1))
                }else{
                    failuresNumber = parseInt(tmp.charAt(0));
                }
            }else{
                failuresNumber = parseInt(tmp.charAt(0));
            }
        }
        summarySF[categoryName].Failures += failuresNumber;
        totalQCount += failuresNumber;
        //Duplicate Code Ends
    }
    var counter = 0;
    for( var keyCatName in summarySF){
        var newItem = new Object();
        //keyCatName = keyCatName.replace("Sharp","#");
        newItem.label= keyCatName
        newItem.x = counter++;
        var clsName = keyCatName;
        if(clsName.indexOf("Custom Custom ")!=-1){
            clsName = clsName.substr("Custom Custom ".length);
        }
        clsName = clsName.trim();
        if (clsName.length > 45){
            newItem.TopicName = "..."+clsName.substr(clsName.length-45,clsName.length);
        } else {
            newItem.TopicName = clsName;
        }
        if(areaName){
            if(areaName == 'Coding'){
                newItem.TopicName = newItem.TopicName+ '(Coding)';
            }
        }
        //newItem.Difficulty = 'Senior';
        newItem.Successes = summarySF[keyCatName].Successes;
        newItem.Failures = summarySF[keyCatName].Failures;
        if(newItem.Failures == 0){
            newItem.y = 1;
            arrColors.push("#66b92e");
        }else if(newItem.Successes == 0){
            newItem.y = 0;
            arrColors.push("#d65b4a");
        }else {
            newItem.y = ((newItem.Successes/(newItem.Successes+newItem.Failures)));
            if(newItem.y<.5){
                arrColors.push("#d65b4a");
            }else if(newItem.y>=.5 && newItem.y<.8){
                arrColors.push("#da932c");
            }else {
                arrColors.push("#66b92e");
            }
        }
        if(keyCatName && keyCatName.indexOf('Coding')!=-1){
            newItem.toolTipContent = "<b>Correct Test Cases Amount:</b> "+newItem.Successes+" out of "+(newItem.Failures+newItem.Successes) ; //<br><b>Difficuly:</b> "+newItem.Difficulty;
        }else{
            newItem.toolTipContent = "<b>Correct Questions Amount:</b> "+newItem.Successes+" out of "+(newItem.Failures+newItem.Successes) ; //<br><b>Difficuly:</b> "+newItem.Difficulty;
        }
        quizResultsList.push(newItem);
    }
    CanvasJS.addColorSet("topicsColorSet",arrColors);
    return quizResultsList;

}

export default Charts;